import { IssueQuickLinks } from '../../../cimsPage/instances/issues'
import { QuickLinks } from '../../common'

const { Create, Edit, RemoveRestore, View } = QuickLinks({
  page: IssueQuickLinks,
  create: 'AA5CB2AD-7AEA-4E1B-9A23-089458499A9B',
  edit: '8674A227-5DB7-4324-A903-97B52D2D5BEC',
  removeRestore: '71A9DDD0-1A24-42FC-8F99-C5802EF44A56',
  view: '3151994C-EF50-4463-8EBE-7F0D18BC0F4A',
})

export const CreateIssueQuickLink = Create
export const EditIssueQuickLink = Edit
export const RemoveRestoreIssueQuickLink = RemoveRestore
export const ViewIssueQuickLink = View

export type IssueQuickLinkPermission =
  | typeof CreateIssueQuickLink
  | typeof EditIssueQuickLink
  | typeof RemoveRestoreIssueQuickLink
  | typeof ViewIssueQuickLink
